var _____WB$wombat$assign$function_____ = function (name) { return (globalThis._wb_wombat && globalThis._wb_wombat.local_init && globalThis._wb_wombat.local_init(name)) || globalThis[name]; }; if (!globalThis.__WB_pmw) { globalThis.__WB_pmw = function (obj) { this.__WB_source = obj; return this; } } {
    let window = _____WB$wombat$assign$function_____("window");
    let document = _____WB$wombat$assign$function_____("document");

    function formValidateform1252() {
        var previousClicked = false;
        var validateInlineClass = "inlineValidated";
        var lastActiveElement = null;
        var formId = "form1252";
        $(".previousPageButton", "#" + formId).click(function () {
            previousClicked = true; return true;
        });

        if ($("#form1252").length > 0 && typeof $("#form1252").validate === "function") {
            var validator = $("#form1252").validate({

                invalidHandler: function (form, validator) {
                    var matrixMessages = new Object();


                    $(".mpErrorSummary ul li", "#" + formId).remove();
                    if ($(".mpErrorSummary", "#" + formId).length == 0) {
                        $("#" + formId).prepend("<div class='mpErrorSummary'><label>" + $("input[name='errorText']", "#" + formId).val() + "</label><ul></ul></div>");
                    }
                    var errorElements = validator.errorList;
                    var len = errorElements.length;
                    if (len > 0) {
                        var matrixQuestions = new Object();
                        $(".mpErrorSummary", "#" + formId).show();
                        for (var i = 0; i < len; i++) {
                            var message = errorElements[i].message || "";
                            var element = errorElements[i].element;
                            var container = getContainer(element);
                            if (container.is('tr')) {
                                container = container.parents('.mpMatrixTable');
                                var matrixId = container.attr("id");
                                if (typeof matrixQuestions[matrixId] == "undefined") {
                                    matrixQuestions[matrixId] = matrixId;
                                    message = matrixMessages[matrixId];
                                    var topContainer = getTopContainer(element);
                                    topContainerId = topContainer.attr("id");
                                    var errorId = "errorfield-" + topContainerId;
                                    $(".mpErrorSummary ul", "#" + formId).append("<li id=" + errorId + ">" + message + "</li>");
                                }
                            } else {
                                var label = getLabel(element);
                                var labelTxt = label.text() != "" ? " (" + label.text() + ")" : "";
                                message = message + labelTxt;
                                var errorId = "errorfield-" + container.attr("id");
                                $(".mpErrorSummary ul", "#" + formId).append("<li id=" + errorId + ">" + message + "</li>");
                            }
                        }
                    } else {
                        $(".mpErrorSummary", "#" + formId).hide();
                    }
                },
                errorPlacement: function (error, element) {
                    var container = getContainer(element);
                    if (container.is('table')) {
                        var errorRow = $(".mpErrorRow", container);
                        if (errorRow.length == 0) {
                            if ($("input[name='formLayout']", "#" + formId).val() == 'N') {
                                errorRow = $('<tr class="mpErrorRow"><td colspan="2"></td></tr>');
                            } else {
                                errorRow = $('<tr class="mpErrorRow"><td></td></tr>');
                            }
                            container.append(errorRow);
                        } else {
                            $("td", errorRow).empty();
                        }
                        $("td", errorRow).append(error);
                    } else if (container.is('li')) {
                        var errorDiv = $("div.mpErrorRow", container);
                        if (errorDiv.length == 0) {
                            errorDiv = $('<div class="mpErrorRow"></div>');
                            container.append(errorDiv);
                        }
                        $(errorDiv).append(error);
                    } else if (container.is('tr')) {
                        var errorRow = container.next(".mpErrorRow");
                        if (errorRow.length == 0) {
                            var colCount = $("td", container).length;
                            errorRow = $('<tr class="mpErrorRow"><td colspan="' + colCount + '"></td></tr>');
                            container.after(errorRow);
                        } else {
                            $("td", errorRow).empty();
                        }
                        $("td", errorRow).append(error);
                    }
                },
                highlight: function (element, errorClass) {
                    var container = getContainer(element);
                    if (container.is('tr')) {
                        container = container.parents('.mpQuestionTable');
                    }
                    container.removeClass(errorClass).addClass(errorClass);
                },
                unhighlight: function (element, errorClass) {
                    var hasError = false;
                    var container = getContainer(element);
                    var questionId = getQuestionId(element);
                    if (container.is('table') || container.is('div')) {
                        var errorBlock = $(".mpErrorRow", container);
                        if (errorBlock.length > 0) {
                            var errorFor = getQuestionIdFromString($("label", errorBlock).attr("for"));
                            if (errorFor == questionId) {
                                errorBlock.remove();
                            } else {
                                hasError = true;
                            }
                        }
                    } else if (container.is('tr')) {
                        errorBlock = container.next(".mpErrorRow");
                        if (errorBlock.length > 0) {
                            errorBlock.remove();
                        }
                        container = container.parents('.mpQuestionTable');
                        hasError = $('.mpErrorRow', container).length > 0;
                    };
                    if (!hasError) {
                        container.removeClass(errorClass);
                    };
                },
                debug: false,
                onkeyup: false,
                onfocusout: false,
                onclick: false,
                ignore: ":hidden",
                errorElement: "label",



                rules: {
                    field1270: {
                        customRequired: true,
                        email: true
                    },
                    field1271: {
                        customRequired: true
                    },
                    field1272: {
                        customRequired: false
                    }
                },
                messages: {
                    field1270: {
                        customRequired: "Vul a.u.b. een e-mailadres in.",
                        email: "U heeft een ongeldig e-mailadres ingevuld."
                    },
                    field1271: {
                        customRequired: "Geef aan datu de nieuwsbrief wil ontvangen"
                    },
                    field1272: {
                        customRequired: ""
                    }
                }


            });
            $.validator.addMethod("customDate", function (value, element) {
                var parent = $(element).parent();
                var date = '';
                $('.mpDateField', parent).each(function () {
                    date = date + $(this).val() + '-';
                });
                if (date == '---') { // empty date is ok
                    date = '';
                    return true;
                }
                date = date.substring(0, date.length - 1);
                var pattern = $('.dateFieldPattern', parent).val();

                return isValidDate(date, pattern);
            });

            $.validator.addMethod("maxAnswers", function (value, element, parms) {
                if (previousClicked) { // No required validations when previous is clicked
                    return true;
                };
                var ul = $(element).parents('ul')[0];
                var checked = $('input:checked', ul).length;
                return checked <= parms;
            });

            $.validator.addMethod("minAnswers", function (value, element, parms) {
                if (previousClicked) { // No required validations when previous is clicked
                    return true;
                };
                var ul = $(element).parents('ul')[0];
                var checked = $('input:checked', ul).length;
                return checked >= parms;
            });

            $.validator.addMethod("money", function (value) {
                var matches = /^\d+([\.,]\d{0,2})*$/.exec(value);
                return (value == '' || matches != null);
            });

            $.validator.addMethod("customRequired", function (value, element) {
                if (previousClicked) { // No required validations when previous is clicked
                    return true;
                };
                return $.validator.methods.required.call(this, value, element);
            });

            $.validator.addMethod("customMin", function (value, element, parms) {
                valueToCheck = Number(value.replace(",", "."));
                minValue = Number(parms.replace(",", "."));
                return (value == '' || valueToCheck >= minValue);
            });

            $.validator.addMethod("customMax", function (value, element, parms) {
                valueToCheck = Number(value.replace(",", "."));
                maxValue = Number(parms.replace(",", "."));
                return (value == '' || valueToCheck <= maxValue);
            });

            $.validator.addMethod("customNumber", function (value) {
                var matches = /^-?\d+$/.exec(value);
                return (value == '' || matches != null);
            });

            $.validator.addMethod("zipCode", function (value) {
                var matches = /^[ ]*[0-9]{4}[ ]*[A-Za-z]{2}[ ]*$/.exec(value);
                return (value == '' || matches != null);
            });

            $.validator.addMethod("telephone", function (value) {
                if (value == '') {
                    return true;
                }
                var number = value;
                var re = new RegExp('[^0-9]', 'g');
                number = number.replace(re, '');
                if (number.length < 10 || number.length > 12) {
                    return false;
                } else if ((number.length == 10) && (number.indexOf('0') != 0)) {
                    return false;
                } else if ((number.length == 11) && (number.indexOf('31') != 0)) {
                    return false;
                } else if ((number.length == 12) && (number.indexOf('310') != 0)) {
                    return false
                }
                return true;
            });

            $.validator.addMethod("telNr", function (value) {
                if (value == '') {
                    return true;
                }
                var number = value;
                var re = new RegExp('[^0-9]', 'g');
                number = number.replace(re, '');
                if (number.length < 10 || number.length > 14) {
                    return false;
                } else if ((number.length == 10) && (number.indexOf('06') != 0)) {
                    return false;
                } else if ((number.length == 11) && (number.indexOf('316') != 0)) {
                    return false;
                } else if ((number.length == 12) && (number.indexOf('3106') != 0)) {
                    return false;
                } else if ((number.length == 13) && (number.indexOf('00316') != 0)) {
                    return false;
                } else if ((number.length == 14) && (number.indexOf('003106') != 0)) {
                    return false;
                }
                return true;
            });

            $.validator.addMethod("regexp", function (value, element, param) {
                var re;
                try {
                    var caseSensitive = '';
                    if (param[1] == 'N') {
                        caseSensitive = 'i';
                    }
                    re = new RegExp(param[0], caseSensitive);
                    return this.optional(element) || re.test(value);
                } catch (e) {
                    return true;
                }
            });
        }



        function isValidDate(date, pattern) {
            var matches = /^(\d{2})[-](\d{2})[-](\d{4})$/.exec(date);
            if (matches == null) return false;
            if (pattern == 'dd-MM-yyyy') {
                var d = matches[1];
                var m = matches[2] - 1;
                var y = matches[3];
            } else if (pattern == 'MM-dd-yyyy') {
                var d = matches[2];
                var m = matches[1] - 1;
                var y = matches[3];
            }

            var composedDate = new Date(y, m, d);
            return composedDate.getDate() == d && composedDate.getMonth() == m && composedDate.getFullYear() == y;

        }

        function getContainer(element) {
            var jqElement = $(element);
            if (jqElement.hasClass("mpOtherCustomInput")) {
                jqElement = jqElement.parent().children(".mpMultipleInput");
            }
            var id = jqElement.attr("id");
            var pos = id.indexOf("-");
            if (pos < 0) {
                pos = id.length;
            }
            var cntId;
            if (id.substring(0, 3) == "fld") {
                cntId = "#CNTT" + id.substring(3, pos);
            } else {
                cntId = "#CNT" + id.substring(5, pos);
            }
            return $(cntId);
        }

        function getQuestionId(element) {
            var jqElement = $(element);
            var id = jqElement.attr("id");
            return getQuestionIdFromString(id);
        }

        function getQuestionIdFromString(idString) {
            var pos = idString.indexOf("-");
            if (pos < 0) {
                pos = idString.length;
            }
            return idString.substring(0, pos);
        }

        function getLabel(element) {
            var container = getContainer(element);
            var label = $(".mpFormLabel label", container);

            return label;
        }

        function getTopContainer(element) {
            var container = getContainer(element);
            if (container.is('tr')) {
                container = container.parents('.mpQuestionTable');
            }
            return container;
        }

        function doFocusin(element) {

            if (!lastActiveElement) {
                lastActiveElement = element;
                return;
            }
            var containerId = null;
            var containerLastActiveId = null;
            if (element.id) {
                var container = getTopContainer(element);
                containerId = container.attr("id");
            }
            if (lastActiveElement.id) {
                var containerLastActive = getTopContainer(lastActiveElement);
                containerLastActiveId = containerLastActive.attr("id");
            }
            if (containerId != containerLastActiveId && containerLastActiveId) {
                $("input, textarea, select", containerLastActive).filter(":visible").each(function (index, element) {
                    doFocusout(element);
                });
            }
            lastActiveElement = element;
        }

        function doFocusout(element) {
            if (getValidateInline()) {
                var check = validator.check(element);
                var empty = validator.getLength(element.value, element) == 0;
                var container = getTopContainer(element);
                var hasError = $(container).hasClass('error');
                if (hasError || check == false || empty == false) {
                    validator.element(element);
                    var containerId = container.attr("id");
                    hasError = $(container).hasClass('error');
                    if (!hasError) {
                        $("#errorfield-" + containerId).remove();
                        if ($(".mpErrorSummary ul li", "#" + formId).length == 0) {
                            $(".mpErrorSummary", "#" + formId).hide();
                        }
                        if (getValidateElementInline(element)) {
                            container.removeClass(validateInlineClass).addClass(validateInlineClass);
                        } else {
                            container.removeClass(validateInlineClass)
                        }
                    } else {
                        container.removeClass(validateInlineClass).addClass(validateInlineClass);
                    }
                }
            }
        }



        $("input, textarea, select", "#" + formId).focusin(focusIn);


        function focusIn() {
            var element = this;
            if (element.type && element.type == 'submit') {
                setTimeout(function () { doFocusin(element); }, 1000);
            } else {
                doFocusin(element);
            }
            return true;
        };

        function getValidateInline() {
            return true;
        }

        var validateInlineSettings = new Object();
        validateInlineSettings["field1270"] = "N"
        validateInlineSettings["field1271-204"] = "N"
        validateInlineSettings["field1272"] = "N"


        function getValidateElementInline(element) {
            return validateInlineSettings[getQuestionId(element)] == "Y";


        }
    };


    function ShowHideform1252() {
        var concealedQuestions = new Array();
        var myself = this;
        var form = $('#form1252');
        this.init = function () {
            var concealedQuestion;


            for (var i = 0; i < concealedQuestions.length; i++) {
                concealedQuestion = concealedQuestions[i];
                var triggerElem;
                if (myself.isMultipleAnswer(concealedQuestion.questionType)) {
                    triggerElem = $("#" + concealedQuestion.answerId);
                    triggerElem.unbind();
                    triggerElem.click(myself.updateShowHide);
                } else {
                    triggerElem = $("#" + concealedQuestion.questionId);
                    triggerElem.unbind();
                    triggerElem.change(myself.updateShowHide);
                }
                myself.doShowHide(triggerElem);
            }
            $('input:not("input[type=submit]"),select,textarea', form).focus(myself.highlightContainer);
            $('input.mpMultipleInputOther', form).each(function () {
                var checked = $(this).prop("checked")
                $(this).parent().children(".mpOtherCustomInput").attr("disabled", !checked);
            });
            $('input[type=checkbox].mpMultipleInputOther', form).click(function () {
                var checked = $(this).prop("checked");
                $(this).parent().children(".mpOtherCustomInput").attr("disabled", !checked);
            });
            $('input[type=radio].mpMultipleInputOther', form).each(function () {
                var container = $(this).parents(".mpQuestionTable");
                var radioId = $(this).attr("id");
                var inputId = $(this).parent().children(".mpOtherCustomInput").attr("id");
                $('input[type=radio]', container).click(function () {
                    if (radioId == $(this).attr("id")) {
                        $("#" + inputId).attr("disabled", false);
                    } else {
                        $("#" + inputId).attr("disabled", true);
                    }
                });
            });



            //$('input:not("input[type=submit]"),select,textarea',form).first().focus();							


        }

        this.highlightContainer = function () {
            $('.mpHighlight', form).removeClass('mpHighlight');
            $(this).parents('.mpQuestionTable').addClass('mpHighlight');
        }

        this.isMultipleAnswer = function (questionType) {
            return myself.isRadioType(questionType) || myself.isCheckboxType(questionType);
        }

        this.isRadioType = function (questionType) {
            var pattern = /radioButton|radioButtonOther|rating4|rating5|rating10|gender|monitor/;
            return pattern.test(questionType);
        }

        this.isCheckboxType = function (questionType) {
            var pattern = /yesNo|checkBox|checkBoxOther/;
            return pattern.test(questionType);
        }

        this.isSelectType = function (questionType) {
            var pattern = /dropDown/;
            return pattern.test(questionType);
        }

        this.doShowHide = function (elem) {
            var elemQuestionId = elem.attr("name");
            var containersToHide = new Object();
            var containersToShow = new Object();
            for (var i = 0; i < concealedQuestions.length; i++) {
                var concealedQuestion = concealedQuestions[i];
                var concealedId;
                var questionId = concealedQuestion.questionId;
                if (myself.isMultipleAnswer(concealedQuestion.questionType)) {
                    concealedId = concealedQuestion.answerId;
                } else {
                    concealedId = questionId;
                }
                if (elemQuestionId == questionId) {
                    if (concealedQuestion.showContainerId.length > 0) {
                        var concealedElement = $("#" + concealedId);
                        if (myself.isMultipleAnswer(concealedQuestion.questionType)) {
                            if (concealedElement.prop("checked")) {
                                containersToShow[concealedQuestion.showContainerId] = concealedQuestion.showContainerId;
                                $("#" + concealedQuestion.showContainerId).show();
                            } else {
                                containersToHide[concealedQuestion.showContainerId] = concealedQuestion.showContainerId;
                            }
                        } else {
                            if (concealedElement.val() == concealedQuestion.answerValue) {
                                containersToShow[concealedQuestion.showContainerId] = concealedQuestion.showContainerId;
                                $("#" + concealedQuestion.showContainerId).show();
                            } else {
                                containersToHide[concealedQuestion.showContainerId] = concealedQuestion.showContainerId;
                            }
                        }
                    }
                }
            }
            for (containerHideId in containersToHide) {
                if (containersToShow[containerHideId] == null) {
                    $("#" + containerHideId).hide();
                }
            };
        }

        this.updateShowHide = function () {
            var elem = $(this);
            myself.doShowHide(elem);
        }

    }

    function initShowHideform1252() {
        function loadjq(head) {
            script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = '//web.archive.org/web/20220331000610/https://static.mailplus.nl/jq/jquery-3.3.1.min.js';
            head.appendChild(script);
        }

        function loadjqValidate(head) {
            script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = '//web.archive.org/web/20220331000610/https://static.mailplus.nl/jq/jquery.validate-1.17.0.min.js';
            head.appendChild(script);
        }

        function loadjqUI(head) {
            script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = '//web.archive.org/web/20220331000610/https://static.mailplus.nl/jq/ui/jquery-ui-1.12.1.custom.min.js';
            head.appendChild(script);

            script = document.createElement('link');
            script.rel = "stylesheet";
            script.href = "//web.archive.org/web/20220331000610/https://static.mailplus.nl/jq/ui/jquery-ui-1.12.1.custom.min.css";
            script.type = "text/css";
            head.appendChild(script);
        }

        var head = document.getElementsByTagName("head")[0];
        if (typeof jQuery == 'undefined') {
            loadjq(head);
            loadjqValidate(head);
            loadjqUI(head);
            setTimeout("initShowHideform1252()", 100)
            return;
        }

        if (!$().validate) {
            loadjqValidate(head);
            setTimeout("initShowHideform1252()", 100)
        }


        formValidateform1252();
        var sh = new ShowHideform1252();
        sh.init();


    }

    if (window.addEventListener) {
        window.addEventListener("load", initShowHideform1252, false);
    } else if (window.attachEvent) {
        window.attachEvent("onload", initShowHideform1252);
    }


}

/*
     FILE ARCHIVED ON 00:06:10 Mar 31, 2022 AND RETRIEVED FROM THE
     INTERNET ARCHIVE ON 13:17:34 Aug 05, 2026.
     JAVASCRIPT APPENDED BY WAYBACK MACHINE, COPYRIGHT INTERNET ARCHIVE.

     ALL OTHER CONTENT MAY ALSO BE PROTECTED BY COPYRIGHT (17 U.S.C.
     SECTION 108(a)(3)).
*/
/*
playback timings (ms):
  captures_list: 0.649
  exclusion.robots: 0.065
  exclusion.robots.policy: 0.052
  esindex: 0.01
  cdx.remote: 60.193
  LoadShardBlock: 396.534 (3)
  PetaboxLoader3.datanode: 252.443 (4)
  PetaboxLoader3.resolve: 189.708 (2)
  load_resource: 247.216
*/